import type { CurvePath, Vector3 } from '@anov/3d-core'

export { StreamerTraffic } from './StreamerTraffic'

export interface StreamerTrafficInterface {

  width: number

  divide: number

  speed: number

  lanelines: CurvePath<Vector3>[]

  num: number

  baseColor: string

  divideWidth: number

}